import { Component, OnInit, OnDestroy, Renderer2 , ViewChild, TemplateRef, ElementRef, AfterViewInit} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';

import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';

import { DeviceDetectorService  } from 'ngx-device-detector';

//import { NavService } from './services/nav.service';



import { Idle ,DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';



import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';



import { AppService } from '../app.service';
import { AuthService } from '../shared/auth.service';
import { AlertmessageService } from '../shared/alertmessage.service';

@Component({
  selector: 'app-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss'],
  providers:[BsModalService,AppService]
})
export class TimeoutComponent implements OnInit 
{


  idleState = 'Not started.';//
  timedOut = false;
  lastPing?: Date = null;
  title = 'angular-idle-timeout';

  public modalRef: BsModalRef;

  @ViewChild('childModal', {  }) childModal: ModalDirective;
  constructor(private idle: Idle, 
    private keepalive: Keepalive,
    private appService:AppService,
    public authService:AuthService,
    private modalService: BsModalService,
    public alert:AlertmessageService,
    public router:Router) 
  { 

     // sets an idle timeout of 5 seconds, for testing purposes.
     idle.setIdle(300);
     // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
     idle.setTimeout(30);
     // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
     idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

     idle.onIdleEnd.subscribe(() => { 
      this.idleState = 'No longer idle.'
      console.log(this.idleState);
      this.reset();
    });


    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      console.log(this.idleState);
      this.authService.logout();
      //this.alert.openConfirmationDialog(this.idleState);
      this.router.navigate(['/']);
    });
    
    idle.onIdleStart.subscribe(() => {
      console.log("TEST");
        this.idleState = 'You\'ve gone idle!'
        console.log(this.idleState);
        this.childModal.show();
    });
    
    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!'
      
      console.log(this.idleState);
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.appService.getUserLoggedIn().subscribe(userLoggedIn => {
      if (userLoggedIn) {
        idle.watch()
        this.timedOut = false;
      } else {
        idle.stop();
      }
    })

    

    //this.reset();

  }
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
  hideChildModal(): void {
    this.childModal.hide();
  }

  stay() {
    this.childModal.hide();
    this.reset();
  }

  logout() {
    this.childModal.hide();
    this.appService.setUserLoggedIn(false);
    this.authService.logout();
    this.router.navigate(['/']);
  }

  ngOnInit() 
  {
    console.log("Timeout component");
  }

}
